function replaceLinkWithButton(link, attributes) {
    const video = $(link);
    const button = $('<button></button>').html(video.html());

    attributes.forEach(function (attribute) {
        const value = video.attr(attribute);

        if (value) {
            button.attr(attribute, value);
        }
    });

    video.replaceWith(button);
}

$('a.video').each(function () {
    replaceLinkWithButton(this, ['class', 'data-mfp-src']);
});

$('a.video-mp4').each(function () {
    replaceLinkWithButton(this, [
        'class',
        'data-src',
        'data-vtt-src',
        'data-vtt-label',
        'data-vtt-srclang',
    ]);
});
